import API from 'services/API/index';

export default function getAvatar() {
  return API.request({
    method: 'GET',
    url: `/profile/getPhoto`,
    responseType: 'arraybuffer',
    mapper: (data) => {
      const bytes = new Uint8Array(data);
      const binary = [].map.call(bytes, (byte) => String.fromCharCode(byte)).join('');
      return bytes.length ? `data:image/jpg;base64,${btoa(binary)}` : undefined;
    },
  });
}
